import { Helmet } from "react-helmet-async";
import {
  ColumnContainer,
  Panel,
  SafePanel,
  Space,
  LimitedContainer,
  RowContainer,
  LimitedContainerMedium,
  LabelXXL,
  LabelXL,
  LabelL,
  Button
} from "../components/Ui/Ui";
import { useNavigate, useParams } from "react-router-dom";
import { jobData } from "../data/JobsItemsPageData";
import { NavToContactPage, scrollToTop } from "../utils/utilities";
import { dataByKey } from "../data/NavBarData";

const KarriereItems = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const job = jobData[type || ""];

  if (!job) return <h2>Job not found</h2>;

  return (
    <>
      <Helmet>
        <title>{job.title} – Karriere</title>
        <meta name="description" content={job.shortDescription} />
      </Helmet>

      <Panel style={{ background: "white", marginTop:"5rem"}}>
        <SafePanel normal={false} allowMargin={false}>
          <ColumnContainer>
            <RowContainer style={{ flexFlow: "nowrap" }}  >
              <LimitedContainerMedium>
                <LabelXXL color="black" fontWeight="900">
                  {job.title}
                </LabelXXL>

              </LimitedContainerMedium>



            </RowContainer>
            <LimitedContainerMedium>
              <LabelL color="black">
                {job.ort} · {job.art}
              </LabelL>

            </LimitedContainerMedium>
            <Space style={{ height: "1rem" }} />
            <LimitedContainer>
              <Button
                onClick={() => {
                  NavToContactPage(navigate, dataByKey.contact.to);
                  scrollToTop();
                }}
              >
                Jetzt Bewerben
              </Button>
            </LimitedContainer>
            <Space style={{ height: "2rem" }} />
            <LimitedContainerMedium>

              <LabelL style={{ color: "black" }}>
                {job.shortDescription}
              </LabelL>
            </LimitedContainerMedium>

            <LimitedContainerMedium>
              <ColumnContainer>
                <LabelL color="black" fontWeight="700">
                  Welche Aufgaben dich erwarten
                </LabelL>
                <ul style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
                  {job.aufgaben.map((item, index) => (
                    <li key={index} style={{ marginBottom: "0.5rem" }}>
                      <LabelL color="black">{item}</LabelL>
                    </li>
                  ))}
                </ul>
              </ColumnContainer>
            </LimitedContainerMedium>
            <Space style={{ height: "2rem" }} />
            <LimitedContainerMedium>
              <ColumnContainer>
                <LabelL color="black" fontWeight="700">
                  Wie passt du in unser Team?
                </LabelL>
                <ul style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
                  {job.team.map((item, index) => (
                    <li key={index} style={{ marginBottom: "0.5rem" }}>
                      <LabelL color="black">{item}</LabelL>
                    </li>
                  ))}
                </ul>
              </ColumnContainer>
            </LimitedContainerMedium>
            <Space style={{ height: "2rem" }} />
            <LimitedContainerMedium>
              <ColumnContainer>
                <LabelL color="black" fontWeight="700">
                  Was wir dir anbieten
                </LabelL>
                <ul style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
                  {job.benefits.map((item, index) => (
                    <li key={index} style={{ marginBottom: "0.5rem" }}>
                      <LabelL color="black">{item}</LabelL>
                    </li>
                  ))}
                </ul>
              </ColumnContainer>
            </LimitedContainerMedium>
          </ColumnContainer>
        </SafePanel>
      </Panel>
    </>
  );
};

const Section = ({ title, items }) => (
  <LimitedContainerMedium>
    <LabelXL color="black" fontWeight="700">
      {title}
    </LabelXL>
    <ul style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
      {items.map((item, index) => (
        <li key={index} style={{ marginBottom: "0.5rem" }}>
          <LabelL color="black">{item}</LabelL>
        </li>
      ))}
    </ul>
  </LimitedContainerMedium>
);

export default KarriereItems;

